import MIDASTA_EXT_1 from "./MIDASTA_EXT_1";
export default {
  MIDASTA_EXT_1,
};
